export default "__VITE_ASSET__CWgmwCg___"